import { render, staticRenderFns } from "./OrgManagement.vue?vue&type=template&id=dd4d7b0e&scoped=true"
import script from "./OrgManagement.vue?vue&type=script&lang=js"
export * from "./OrgManagement.vue?vue&type=script&lang=js"
import style0 from "./OrgManagement.vue?vue&type=style&index=0&id=dd4d7b0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4d7b0e",
  null
  
)

export default component.exports